export enum EmailTriggers {
  DIRECT = 'direct',
  JOB = 'job',
  MANUAL = 'manual',
}
